import * as moment from 'moment';

export class DateOnlyFormatNoConversionValueConverter {
    toView(value: Date) {
        return moment(value).format('YYYY-MM-DD');
    }
}